import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import WatchingPreviewProfileMetric from './watching-preview-profile-metric-model'
import {
  CreateWatchingPreviewProfileMetricAsync,
  DeleteWatchingPreviewProfileMetricAsync,
  LoadWatchingPreviewProfileMetricsAsync,
} from './watchingPreviewProfileMetric-thunk'
const initialState: watchingPreviewProfileMetricSliceState = {
  watchingPreviewProfileMetric: [],
  selected_watchingPreviewProfileMetric: '',
  is_loading_watchingPreviewProfileMetric: false,
  is_creating_watchingPreviewProfileMetric: false,
  is_deleting_watchingPreviewProfileMetric: false,
}
export interface watchingPreviewProfileMetricSliceState {
  watchingPreviewProfileMetric: WatchingPreviewProfileMetric[]
  selected_watchingPreviewProfileMetric?: string
  is_loading_watchingPreviewProfileMetric: boolean
  is_creating_watchingPreviewProfileMetric: boolean
  is_deleting_watchingPreviewProfileMetric: boolean
}
export const watchingPreviewProfileMetricSlice = createSlice({
  name: 'watchingPreviewProfileMetric',
  initialState,
  reducers: {
    setSelectedwatchingPreviewProfileMetric: (state, action) => {
      state.selected_watchingPreviewProfileMetric = action.payload
    },
    clearStatewatchingPreviewProfileMetric: (state) => {
      state.watchingPreviewProfileMetric = []
      state.is_loading_watchingPreviewProfileMetric = false
      state.is_creating_watchingPreviewProfileMetric = false
      state.is_deleting_watchingPreviewProfileMetric = false
    },
    mergewatchingPreviewProfileMetric: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_watchingPreviewProfileMetric = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.watchingPreviewProfileMetric = merge(
            state.watchingPreviewProfileMetric,
            payload,
          ) as any
        }
      }
    },

    add_watchingPreviewProfileMetric: (state, action) => {
      if (action.payload) {
        state.watchingPreviewProfileMetric = [
          ...state.watchingPreviewProfileMetric,
          action.payload,
        ]
      }
    },
    set_watchingPreviewProfileMetric: (state, action) => {
      let { key, value, id } = action.payload
      state.watchingPreviewProfileMetric =
        state.watchingPreviewProfileMetric.map((item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadWatchingPreviewProfileMetricsAsync.pending, (state) => {
      state.is_loading_watchingPreviewProfileMetric = true
    })
    builder.addCase(
      LoadWatchingPreviewProfileMetricsAsync.fulfilled,
      (state, action) => {
        state.is_loading_watchingPreviewProfileMetric = false
        if (action.payload) {
          state.watchingPreviewProfileMetric = action.payload
        }
      },
    )
    builder.addCase(
      LoadWatchingPreviewProfileMetricsAsync.rejected,
      (state) => {
        state.is_loading_watchingPreviewProfileMetric = false
      },
    )
    builder.addCase(
      CreateWatchingPreviewProfileMetricAsync.pending,
      (state) => {
        state.is_creating_watchingPreviewProfileMetric = true
      },
    )
    builder.addCase(
      CreateWatchingPreviewProfileMetricAsync.fulfilled,
      (state) => {
        state.is_creating_watchingPreviewProfileMetric = false
      },
    )
    builder.addCase(
      CreateWatchingPreviewProfileMetricAsync.rejected,
      (state) => {
        state.is_creating_watchingPreviewProfileMetric = false
      },
    )
    builder.addCase(
      DeleteWatchingPreviewProfileMetricAsync.pending,
      (state) => {
        state.is_deleting_watchingPreviewProfileMetric = true
      },
    )
    builder.addCase(
      DeleteWatchingPreviewProfileMetricAsync.fulfilled,
      (state, action) => {
        state.is_deleting_watchingPreviewProfileMetric = false
        if (state.watchingPreviewProfileMetric) {
          state.watchingPreviewProfileMetric =
            state.watchingPreviewProfileMetric.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(
      DeleteWatchingPreviewProfileMetricAsync.rejected,
      (state) => {
        state.is_deleting_watchingPreviewProfileMetric = false
      },
    )
  },
})

export const {
  clearStatewatchingPreviewProfileMetric,
  setSelectedwatchingPreviewProfileMetric,
  set_watchingPreviewProfileMetric,
  mergewatchingPreviewProfileMetric,
  add_watchingPreviewProfileMetric,
} = watchingPreviewProfileMetricSlice.actions

export const get_watchingPreviewProfileMetric =
  (id?: string) =>
  (state: {
    watchingPreviewProfileMetric: {
      watchingPreviewProfileMetric: WatchingPreviewProfileMetric[]
    }
  }): WatchingPreviewProfileMetric | null => {
    let temp =
      state?.watchingPreviewProfileMetric?.watchingPreviewProfileMetric?.find(
        (v) => v.id === id,
      )
    if (temp) {
      return temp
    }
    return (
      state?.watchingPreviewProfileMetric?.watchingPreviewProfileMetric[0] ||
      null
    )
  }
export const get_selected_watchingPreviewProfileMetric = (state: {
  watchingPreviewProfileMetric: watchingPreviewProfileMetricSliceState
}): WatchingPreviewProfileMetric | null => {
  let id =
    state?.watchingPreviewProfileMetric?.selected_watchingPreviewProfileMetric
  let temp =
    state?.watchingPreviewProfileMetric?.watchingPreviewProfileMetric?.find(
      (v) => v.id === id,
    )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_watchingPreviewProfileMetric = (state: {
  watchingPreviewProfileMetric: {
    watchingPreviewProfileMetric: WatchingPreviewProfileMetric[]
  }
}): WatchingPreviewProfileMetric[] => {
  let temp = state?.watchingPreviewProfileMetric?.watchingPreviewProfileMetric
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_watchingPreviewProfileMetric_busy = (state: {
  watchingPreviewProfileMetric: watchingPreviewProfileMetricSliceState
}) => {
  return (
    state?.watchingPreviewProfileMetric
      .is_deleting_watchingPreviewProfileMetric ||
    state?.watchingPreviewProfileMetric
      .is_loading_watchingPreviewProfileMetric ||
    state?.watchingPreviewProfileMetric.is_creating_watchingPreviewProfileMetric
  )
}
export const is_deleting_watchingPreviewProfileMetric_busy = (state: {
  watchingPreviewProfileMetric: watchingPreviewProfileMetricSliceState
}) => {
  return state?.watchingPreviewProfileMetric
    .is_deleting_watchingPreviewProfileMetric
}
export const is_loading_watchingPreviewProfileMetric_busy = (state: {
  watchingPreviewProfileMetric: watchingPreviewProfileMetricSliceState
}) => {
  return state?.watchingPreviewProfileMetric
    .is_loading_watchingPreviewProfileMetric
}
export const is_creating_watchingPreviewProfileMetric_busy = (state: {
  watchingPreviewProfileMetric: watchingPreviewProfileMetricSliceState
}) => {
  return state?.watchingPreviewProfileMetric
    .is_creating_watchingPreviewProfileMetric
}

export default watchingPreviewProfileMetricSlice.reducer
